import { FC, useCallback, useEffect, useContext, useMemo } from 'react';
import { Box, Select } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { VariablesContext } from '../context';
import { useActions, useSelector } from '../../../../hooks';

export const SelectAssistantId: FC = () => {
  const { endpoint, variables, setVariables } = useContext(VariablesContext);
  const { t } = useTranslation();

  const loadingAssistants = useSelector(({ entityStates }) => entityStates.assistants.loading);
  const assistantById = useSelector(({ workspaceResources }) => workspaceResources.assistants.byId);

  const { getAssistants } = useActions(({ assistantActions }) => ({
    getAssistants: assistantActions.listAssistants,
  }));

  const assistantItems = useMemo(
    () =>
      Object.entries(assistantById).map(([id, assistant]) => {
        return {
          label: assistant.name,
          value: id,
        };
      }),

    [assistantById],
  );

  useEffect(() => {
    if (endpoint.includes('assistantId')) {
      getAssistants();
    }
  }, [endpoint]);

  const onChange = useCallback(
    (assistantId: string) => {
      setVariables({ assistantId });
    },
    [setVariables],
  );

  let placeholder = assistantItems.length ? `${t('choose')}...` : t('noAssistants');
  if (loadingAssistants) {
    placeholder = t('loading');
  }

  return !endpoint.includes('assistantId') ? null : (
    <Box mb={20}>
      <Select
        label={t('chooseAssistant')}
        items={assistantItems}
        onChange={onChange}
        disabled={loadingAssistants || assistantItems.length < 1}
        value={variables.assistantId}
        placeholder={placeholder}
      />
    </Box>
  );
};
